import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label, Row } from "reactstrap";

import WYSISYGComponent from "../inputs/WYSISYGComponent";
import useDropzoneFacade from "../../../hooks/useDropzoneFacade";
import FormGroupImages from "../inputs/FormGroupImages";
import FormGroupVideo from "../inputs/FormGroupVideo";
import {
  ERROR_MAX_IMAGES,
  ERROR_MAX_VIDEOS,
  MAX_FILES_COUNT_VIDEOS,
} from "../../../constants/dropzone";

import styles from "../forms.module.scss";
import FormGroupText from '../inputs/FormGroupText';
import { AvCheckbox, AvCheckboxGroup } from 'availity-reactstrap-validation';
import { BLOCK_FOR } from '../../../constants/lessonsDefaults';
import { VALUE_FIELD_ID } from '../../../constants/selectConstants';
import FormGroupMultiSelect from '../inputs/FormGroupMultiSelect';

const previewLessonBlockValue = 'PreviewLessonBlock';

const LessonBlock = ({
  handleFormChange,
  index,
  data,
  addBlockHandler,
  updateFiles,
  setThumbnailAndVideoSuccess,
  setUpdatedThumbnails,
  isPreviewLesson,
  isDirectLinkPreviewLesson,
  blockFor,
  updateFormData,
  fileTagsData,
  formData,
  videoLibraryData,
  getVideoLibraryOptions,
}) => {

  const [editorValue, updateValue] = useState("");
  const [deleteImagesIds, updateDeleteImagesIds] = useState([]);
  const [deleteVideosIds, updateDeleteVideosIds] = useState([]);
  const [
    error,
    selectedImages,
    handleAcceptedImages,
    setSelectedImages,
    setErrorImages,
  ] = useDropzoneFacade({
    validationErrors: { maxFiles: ERROR_MAX_IMAGES },
  });
  const [
    errorVideos,
    selectedVideos,
    handleAcceptedVideos,
    setSelectedVideos,
    setErrorVideo,
  ] = useDropzoneFacade({
    type: "video",
    validationErrors: { maxFiles: ERROR_MAX_VIDEOS },
  });

  const [
    thumbnailError,
    selectedThumbnailImages,
    handleTumbunalAcceptedFiles,
    setSelectedThumbnailImages,
    setError,
    errorFileId,
  ] = useDropzoneFacade();
  const [
    loadedThumbnailError,
    selectedLoadedThumbnailImages,
    handleLoadedTumbunalAcceptedFiles,
    setSelectedLoadedThumbnailImages,
    setLoadedError,
    errorLoadedIndex,
  ] = useDropzoneFacade();

  const blockName = useMemo(() => `block${index + 1}`, [index]);

  const getOverviewVideoValue = useMemo(() => {
    if (!!data && !!data.videosUploaded && !!data.videosUploaded.length) {
      return data.videosUploaded.map(({ id, title }) => {
        return {
          id: id,
          name: `${id} | ${title}`,
        }
      });
    }
  }, [data]);

  //Here Do not Remove JSON.stringify, we want that if new tags are added for video make the useEffect of updateFiles rerun, here currentVideoTags one is pending we will see that when doing update
  const videoTagsValues = useMemo(() => {
    return JSON.stringify(Object.keys(formData)
      .filter(key => key.startsWith('newVideoTags'))
      .map(key => formData[key]));
  }, [formData]);

  const currentVideoTagsValues = useMemo(() => {
    return JSON.stringify(Object.keys(formData)
      .filter(key => key.startsWith('currentVideoTags'))
      .map(key => formData[key]));
  }, [formData]);

   

  const addBlockClicked = (e) => {
    e.preventDefault();
    addBlockHandler();
  };

  useEffect(() => {
    // For new videos tags we are using index as a part of key
    const videosWithThumbnail = selectedVideos.map((video, index) => ({
      video,
      thumbnail: selectedThumbnailImages[index],
      tags: formData[`newVideoTags${blockName}_${index}`] || [],
    }));

    let updatedVideoThumbnails = [];
    
    if (
      !!selectedLoadedThumbnailImages?.length &&
      !!data?.videosUploaded?.length
    ) {
      updatedVideoThumbnails = selectedLoadedThumbnailImages
        .filter((thumbnail) => !!thumbnail)
        .map((thumbnail, index) => ({
          videoId: data.videosUploaded[index].id,
          thumbnail,
        }));
    }


    let updatedVideoTags = [];

    if (!!data?.videosUploaded?.length) {
      // For current videos tags we are using video id as a part of key
      for (const videoUploaded of data.videosUploaded) {
        const tags = formData[`currentVideoTags${blockName}_${videoUploaded.id}`];
        if (!tags) {
          // Let wait for the currentVideoTags to appear in formData
          continue;
        }

        const updatedTagsStringify = JSON.stringify(tags);
        const currentTagsStringify = JSON.stringify(videoUploaded.fileTags.map(tag => tag.name));

        // The initial tags value is being set as empty array => so we will only be allowing change of tag and not supporting the complete removal of tags
        if (updatedTagsStringify !== '[]' && updatedTagsStringify !== currentTagsStringify) {
          updatedVideoTags.push({
            videoId: videoUploaded.id,
            tags,
          });
        }
      }
    }

    updateFiles({
      blockName,
      deleteImagesIds,
      deleteVideosIds,
      images: selectedImages,
      videos: videosWithThumbnail,
      updatedVideoThumbnails,
      updatedVideoTags,
    });
  }, [
    selectedImages,
    selectedVideos,
    deleteImagesIds,
    deleteVideosIds,
    selectedThumbnailImages,
    selectedLoadedThumbnailImages,
    data.videosUploaded,
    videoTagsValues,
    currentVideoTagsValues
  ]);

  useEffect(() => {
    if (!!data?.videosUploaded?.length) {
      const thumbnails = [];
      data.videosUploaded.forEach((video) => {
        if (video.thumbnailImage) {
          video.thumbnailImage.preview = video.thumbnailImage.link;
          video.thumbnailImage.size = null;
          thumbnails.push(video.thumbnailImage);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (selectedVideos.length) {
      const thumbnailImages = selectedThumbnailImages.filter(
        (thumbnail) => !!thumbnail
      );

      setThumbnailAndVideoSuccess(
        thumbnailImages?.length === selectedVideos?.length
      );
    }
  }, [selectedThumbnailImages, selectedVideos]);

  useEffect(() => {
    setUpdatedThumbnails(!!selectedLoadedThumbnailImages?.length);
  }, [selectedLoadedThumbnailImages]);

  return (
    <Card>
      <CardBody>
        <CardTitle>Block #{index + 1}</CardTitle>
        {blockFor === BLOCK_FOR.lesson && <FormGroup className='mb-4' row>
          <Col lg={2}>
            <Label>Is Preview Lesson Block</Label>
          </Col>
          <Col lg={10}>
            <AvCheckboxGroup className='' name={`${blockName}.previewLessonBlock`}>
              <AvCheckbox
                disabled={!isPreviewLesson && !isDirectLinkPreviewLesson}
                onChange={handleFormChange}
                className="cursor-pointer"
                customInput
                label="Is Preview Lesson Block"
                value={previewLessonBlockValue}
              />
            </AvCheckboxGroup>
          </Col>
        </FormGroup>}
        <FormGroupText
          name={`${blockName}.ordinalNumber`}
          label="Ordinal Number"
          placeholder="Enter Ordinal Number"
          handleFormChange={handleFormChange}
        />
        <WYSISYGComponent
          name={`${blockName}.text`}
          label="Text"
          handleFormChange={handleFormChange}
          valueReflectFunction={(value) => updateValue(value)}
        />
        <FormGroupText
          name={`${blockName}.typeFormId`}
          label="TypeForm ID"
          placeholder="Enter TypeForm ID"
          handleFormChange={handleFormChange}
        />
        <FormGroupImages
          multiple={true}
          label="Images"
          error={error}
          selectedImages={selectedImages}
          imagesUploaded={data.imagesUploaded}
          handleAcceptedImages={handleAcceptedImages}
          setSelectedImages={setSelectedImages}
          updateDeleteImagesIds={(ids) => updateDeleteImagesIds(ids)}
          setError={setErrorImages}
        />
        {/* <FormGroupVideo
          withThumbnail
          withTag
          multiple={true}
          label="Videos"
          error={errorVideos}
          selectedVideos={selectedVideos}
          videosUploaded={data.videosUploaded}
          handleAcceptedVideos={handleAcceptedVideos}
          setSelectedVideos={setSelectedVideos}
          updateDeleteVideosIds={(ids) => updateDeleteVideosIds(ids)}
          setError={setErrorVideo}
          thumbnailError={thumbnailError}
          selectedThumbnailImages={selectedThumbnailImages}
          handleTumbunalAcceptedFiles={handleTumbunalAcceptedFiles}
          setSelectedThumbnailImages={setSelectedThumbnailImages}
          loadedThumbnailError={loadedThumbnailError}
          errorIndex={errorFileId}
          selectedLoadedThumbnailImages={selectedLoadedThumbnailImages}
          handleLoadedTumbunalAcceptedFiles={handleLoadedTumbunalAcceptedFiles}
          setSelectedLoadedThumbnailImages={setSelectedLoadedThumbnailImages}
          errorLoadedIndex={errorLoadedIndex}
          updateFormData={updateFormData}
          handleFormChange={handleFormChange}
          fileTagsData={fileTagsData}
          groupIdentifier={blockName}
        /> */}

{/* <FormGroupMultiSelect
                      name={`currentVideoTags`}
                      label="Tags"
                      placeholder="Select tags"
                      value={[]}
                      options={[]}
                      handleFormChange={handleFormChange}
                      updateFormState={updateFormData}
                      maxCreateLength={30}
                      isMulti={false}
                    /> */}

        <FormGroupMultiSelect
            name={`${blockName}.videoIds`}
            allowCreate={false}
            label="Videos"
            placeholder="Choose videos from video library"
            value={getOverviewVideoValue}
            options={videoLibraryData.map(({ id, title }) => ({
              id: id,
              name: `${id} | ${title || '-'}`,
            }))}
            // validator={formsValidators.course.overviewVideoId}
            handleFormChange={handleFormChange}
            formState={formData}
            updateFormState={updateFormData}
            isMulti={true}
            optionValueName={VALUE_FIELD_ID}
            loadOptions={getVideoLibraryOptions}
            styles={{
              // Fixes the overlapping problem of the component
              menu: provided => ({ ...provided, zIndex: 9999 })
            }}
            maxSelectedOptionLimit={MAX_FILES_COUNT_VIDEOS}
          />

        {data.ableToAdd && (
          <Row>
            <Col className="offset-2">
              <Button
                color="success"
                className={styles.btnSave}
                onClick={addBlockClicked}
              >
                Add block
              </Button>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

export default LessonBlock;
